
import { WeeklyView } from "../components/WeeklyTimesheet/WeeklyView";

const WeeklyTimesheet = () => {
  return <WeeklyView />;
};

export default WeeklyTimesheet;
